import {observer} from "mobx-react";
import React from "react";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import FontHeading4 from "../../../components/fonts/font-heading4/font-heading4";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import {FormField} from "../../../components/form-field/form-field";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import Stepper, {STEPPER_LABEL_POSITION} from "../../../components/stepper/stepper";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import {IValidationGroup} from "../../../hooks/validation-group/validation-group-hook";
import CreateRmaSettingsStore from "../stores/create-rma-settings-store";
import RequestProductStore from "../stores/request-product-store";
import GodModeItemDrawerFields from "./god-mode-item-drawer-fields";
import PolicyLedModeItemDrawerFields from "./policy-led-mode-item-drawer-fields";
import { CREATE_RMA_MODE } from "../../../services/api/create-rma-service";
import ReturnReasonSelect from "./return-reason-select/return-reason-select";
import FollowUpQuestionList from "./follow-up-question-list";
import Hr from "../../../components/hr/hr";

interface IProps{
	store:RequestProductStore;
	vGroup:IValidationGroup;
    createRmaSettingsStore: CreateRmaSettingsStore;
}
const RmaItemFields:React.FC<IProps> = observer(({store, vGroup, createRmaSettingsStore})=>{
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

	return (
		<ListLayout>
			<FontHeading4 variant={FONT_VARIANT.BOLD}>{getTranslation('RETURN_DETAILS', pageScope)}</FontHeading4>
			<Stepper
				value={store.quantity!}
				onChange={store.setQuantity}
				max={store.getAvailableQuantity()}
				min={0}
				label={getTranslation('ITEMS', pageScope)}
                singleItemLabel={getTranslation('ITEM', pageScope)}
                labelPosition={STEPPER_LABEL_POSITION.LEFT}
                title={<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RETURN_QUANTITY', pageScope)}</FontBody2>}></Stepper>
			
			<FormField label={<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RETURN_REASON', pageScope)}</FontBody2>} required={true}>
				<ReturnReasonSelect store={store} vGroup={vGroup} createRmaSettingsStore={createRmaSettingsStore} />
			</FormField>
			{createRmaSettingsStore.showFuqs &&
				<>
					<FormField label=''>
						<FollowUpQuestionList requestProductStore={store} />
					</FormField>
					<Hr/>
				</>
			}
			{createRmaSettingsStore.cRmaMode === CREATE_RMA_MODE.C_RMA_GOD_MODE ?
				<GodModeItemDrawerFields
					store={store}
					vGroup={vGroup}
					createRmaSettingsStore={createRmaSettingsStore}
				/>
				:
				<PolicyLedModeItemDrawerFields
					store={store}
					vGroup={vGroup}
					createRmaSettingsStore={createRmaSettingsStore}
				/>
			}
			
		</ListLayout>
	)
});

export default RmaItemFields;